module.exports = __webpack_public_path__ + "r-v3/img/ico_camera_white.f2bd0e46.svg";